import React, { FC, ReactNode } from 'react';
import { CardHeader, CardContent, CardFooter } from './components';

type CardProps = {
    children: ReactNode;
    className?: string;
};

const Card: FC<CardProps> & {
    Header: typeof CardHeader;
    Content: typeof CardContent;
    Footer: typeof CardFooter;
} = ({ children, className }) => {
    return (
        <div className={className}>{children}</div>
    );
};

Card.Header = CardHeader;
Card.Content = CardContent;
Card.Footer = CardFooter;



export default Card;